import React from 'react';
import { getAvailableCountries, DEFAULT_COUNTRY } from '../../data/sosNumbers';

/**
 * @component CountrySelector
 * @description Selector de país con pestañas para página SOS
 */

interface CountrySelectorProps {
  /** País actualmente seleccionado */
  selectedCountry: string;
  /** Función para cambiar país */
  onCountryChange: (countryId: string) => void;
}

const CountrySelector: React.FC<CountrySelectorProps> = ({
  selectedCountry,
  onCountryChange
}) => {
  const countries = getAvailableCountries();

  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8 overflow-x-auto" aria-label="Países">
        {countries.map((country) => (
          <button
            key={country.id}
            onClick={() => onCountryChange(country.id)}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200
              ${selectedCountry === country.id
                ? 'border-red-500 text-red-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
            aria-current={selectedCountry === country.id ? 'page' : undefined}
            type="button"
          >
            {country.nombre}
            {country.id === DEFAULT_COUNTRY && (
              <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                Por defecto
              </span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default CountrySelector;
